import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import Header from "./components/Layouts/Header/Header";
import TopColumns from "./components/Layouts/TopColumns/TopColumns";
import BottomColumns from "./components/Layouts/BottomColumns/BottomColumns";
import FullWidth from "./components/Layouts/FullWidth/FullWidth";
import MiddleColumns from "./components/Layouts/MiddleColumns/MiddleColumns";

const rootElement = document.getElementById('main-content');
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <Header />
            <FullWidth />
            <TopColumns />
            <MiddleColumns />
            <BottomColumns />
        </React.StrictMode>
    );
} else {
    console.error('React root element not found');
}
